export default {
  id: null,
  flowId: null,
  builderId: null,
  isBuilderReady: false,

  builderOptions: {},

  viewerMode: false,

  lastSaved: null,
  saveError: null,
  isPublishing: false,
  isAutoSaving: false,
  isApplyingUpdate: false,
  isSendingPreview: false,

  // properties to determine the minimum patch during auto-saving
  lastContentHashMap: null /** @type { [contentId]: hash_sum } */,
  lastRootId: null,
  lastCoordinates: null,

  // ui
  flowChartMode: false,
}
